/**
 * 批量修改style
 * @param {{HTMLElement}} el
 * @param {Object} styles 样式的对象
 */
export function setStyle(el, styles) {
  let { cssText } = el.style

  for (const atr in styles) {
    if (styles.hasOwnProperty(atr)) {
      cssText += `${atr}:${styles[atr]};`
    }
  }
  el.style.cssText = cssText
}

/**
 * 检测浏览器是否支持某个css属性
 * @param  {String} prop  属性名
 * @param  {String} value 属性值
 * @return {Boolean} true:支持 否则不支持
 */
export function cssSupported(prop, value) {
  const d = document.createElement('div')
  d.style[prop] = value
  return d.style[prop] === value
}
